import React, { useEffect, useState } from "react";
import ButtonContainer from "../../../Components/CheckableButton/ButtonContainer";
import CheckableButton from "../../../Components/CheckableButton/CheckableButton";
import ModalComponent from "../../../Components/Modal/Modal";
import { API } from "../../../API";
import { Tabs } from "@mui/material";
import CollegeContainer from "../../Container/CollegeContainer";
import { connect } from "react-redux";
import { APIMETHOD } from "../../../v2/API";
import { customer } from "../../../v2/endpoints/customer";
import moment from "moment/moment";
import { notify } from "react-notify-toast";
import MultipleSelectChip from "../../../Components/MultipleSelectChip/MultipleSelectChip";
import CloseIcon from '@mui/icons-material/Close';
import FormField from "../../../Components/FormField/FormField";
import HoverIcon from "../../../Components/FormField/HoverIcon-nova";
import { Placeholder } from "semantic-ui-react";
import FormDatePicker from "../../../Components/FormField/FormDatePicker";
import FormDropdown from "../../../Components/FormField/FormDropdown";

const FinanceSetting = (props) => {
    const college = JSON.parse(JSON.parse(window.localStorage['persist:root']).college);
    const user = JSON.parse(JSON.parse(window.localStorage['persist:root']).college)?.user;
    let [paymentDateOption, setPaymentDateOption] = useState("");
    let [periodPayment, setPeriodPayment] = useState([]);
    let [isPaymentDateCheck, setIsPaymentDateCheck] = useState("");
    let [dateGroupA, setDateGroupA] = useState("");
    let [dateGroupB, setDateGroupB] = useState("");
    let [typeNumberInvoices, setTypeNumberInvoices] = useState("");
    let [totalNumberInvoices, setTotalNumberInvoices] = useState(0);
    let [isOpenPopupSplitInvoice, setIsOpenPopupSplitInvoice] = useState(false);
    let [listSplitInvoices, setListSplitInvoices] = useState([]);
    let [selectedInvoice, setSelectedInvoice] = useState(-1);
    let [selectCampusOfInvoice, setSelectCampusOfInvoice] = useState([]);
    let [disableCampusOfOtherInvoice, setDisableCampusOfOtherInvoice] = useState([]);
    let [data, setData] = useState([]);
    let [approvers, setApprovers] = useState([]);
    let [viewers, setViewers] = useState([]);
    let [isPopupAddPersonnel, setIsPopupAddPersonnel] = useState(false);
    let [newPersonnel, setNewPersonnel] = useState({
        personnel_email: "", personnel_role: "", personnel_first_name: "", personnel_last_name: "", campuses: []
        , personnel_departments: [], reference_name: "", get_booking_email: false, inst_id: user?.institution_id
    });
    let [personnels, setPersonnels] = useState([]);
    let [isDisabled, setIsDisabled] = useState(false);
    let [isOpenCustomDatePopup, setIsOpenCustomDatePopup] = useState(false);
    let [customPeriodSetting, setCustomPeriodSetting] = useState({ start_date: new Date(), end_date: new Date(), payment_date_option: "" });
    const [campuses, setCampuses] = useState([]);
    const [existedPersonnels, setExistedPersonnels] = useState(college?.personnel);
    const [purchaseOrder, setPurchaseOrder] = useState({
        date_of_purchase_order_commencement: new Date(),
        po_number: ""
    });

    useEffect(() => {
        API.financeSettingForCustomer(user.institution_id)
            .then(result => {
                const invoiceSetting = result?.data?.data[0];
                setData(invoiceSetting);
                if (invoiceSetting) {
                    setPaymentDateOption(invoiceSetting?.payment_setting?.payment_date_option);
                    setIsPaymentDateCheck(invoiceSetting?.payment_setting?.payment_date_option);
                    setTypeNumberInvoices(invoiceSetting.notification_setting?.split_invoice_type?.split_type ?? "");
                    setTotalNumberInvoices(invoiceSetting.notification_setting?.split_invoice_type?.total_invoice ?? '0');
                    if (invoiceSetting?.notification_setting?.split_campuses?.length > 0) {
                        handleDataSplitInvoice(invoiceSetting);
                    }
                    if (invoiceSetting?.custom_period_setting) {
                        setCustomPeriodSetting(invoiceSetting?.custom_period_setting)
                    }
                }
                handleCheckSelectedSetting(invoiceSetting?.payment_setting?.payment_date_option,
                    invoiceSetting.notification_setting?.split_invoice_type?.split_type,
                    invoiceSetting?.notification_setting?.split_campuses);
                if (invoiceSetting?.payment_setting?.purchase_order) {
                    setPurchaseOrder(invoiceSetting?.payment_setting?.purchase_order);
                }
            }).catch((err) => {
                console.log(err)
            }
            );
        API.getPersonnelByInstIdV2(user?.institution_id).then((response) => {
            setPersonnels(response?.data?.data);
        });
        API.listCampusesHaveBooking().then((response) => {
            setCampuses(response?.data?.data)
        });
        fetchPaymentDate();
    }, []);

    const handleDataSplitInvoice = (invoiceSetting) => {
        if (invoiceSetting?.notification_setting?.split_campuses?.length > 0) {
            setSelectCampusOfInvoice(invoiceSetting?.notification_setting?.split_campuses);
            setSelectedInvoice("0");
            let otherCampuses = invoiceSetting?.notification_setting?.split_campuses.filter(item => item.invoiceId != 0) || [];
            if (otherCampuses.length > 0) {
                let campuses = [];
                otherCampuses.forEach(item => {
                    if (item?.campuses?.length > 0) {
                        campuses = [...campuses, ...item.campuses];
                    }
                });
                setDisableCampusOfOtherInvoice(campuses);
            } else {
                setDisableCampusOfOtherInvoice([]);
            }
        }
    }

    const fetchPaymentDate = () => {
        APIMETHOD.get(customer.fetchPaymentDateForToday, {}).then(result => {
            if (result?.data?.length > 0) {
                result.data.forEach(item => {
                    if (item.belongs_to_group == 'Group A') {
                        setDateGroupA(item);
                    } else {
                        setDateGroupB(item);
                    }
                });
            }
        });
    }

    const tabs = [
        {
            text: "Campus",
            pathname: "/Campus",
        },
        {
            text: "Personnel",
            pathname: "/Personnel",
        },
        {
            text: user?.is_childcare_centre ? "Shifts" : "Timetable",
            pathname: "/TimeTable",
        },
        {
            text: "Finance Settings",
            pathname: "/FinanceSetting",
            active: true,
        },
        {
            text: "Budget Settings",
            pathname: "/BudgetSetting",
        },
    ];

    const handleCheckPaymentDate = (event) => {
        const selectedValue = event.target.value;
        setPaymentDateOption(selectedValue);
        setIsPaymentDateCheck(selectedValue);

        const period = (group) => ({
            start_date: group?.fortnight_start_date,
            end_date: group?.fortnight_end_date,
            invoice_date: group?.teachers_payment_date
        });

        switch (selectedValue) {
            case "payment-date-1":
                setPeriodPayment(period(dateGroupA));
                break;
            case "payment-date-2":
                setPeriodPayment(period(dateGroupB));
                break;
            case "custom-payment-date":
                setPeriodPayment({
                    start_date: new Date(),
                    end_date: new Date(),
                    invoice_date: new Date()
                });
                break;
        }
        handleCheckSelectedSetting(selectedValue, typeNumberInvoices, selectCampusOfInvoice);
    }

    const handleCheckSelectedSetting = (dateOption, typeInvoices, invoiceCampuses) => {
        if (!dateOption || !typeInvoices || (typeInvoices === 'split-campuses' && invoiceCampuses?.length <= 1)) {
            setIsDisabled(true);
        } else {
            setIsDisabled(false);
        }
    }

    const handleSplitInvoices = () => {
        let numberInvoices = [];
        for (let index = 0; index < totalNumberInvoices; index++) {
            numberInvoices.push({ description: `Invoice ${index + 1}` });
        }
        setListSplitInvoices(numberInvoices);
    }

    const handleAddInvoices = () => {
        let numberInvoices = parseInt(totalNumberInvoices) + 1;
        listSplitInvoices.push({ description: `Invoice ${numberInvoices}` });
        setTotalNumberInvoices(numberInvoices);
        setListSplitInvoices(listSplitInvoices);
        selectCampusOfInvoice.push({ invoiceId: totalNumberInvoices.toString(), campuses: [], approvers: [], viewers: [] });
        setSelectCampusOfInvoice(selectCampusOfInvoice);
    }

    const handleSelectedInvoices = (e) => {
        if (e.target.checked) {
            setSelectedInvoice(e.target.id);
            setApprovers(selectCampusOfInvoice[e.target.id]?.approvers || []);
            setViewers(selectCampusOfInvoice[e.target.id]?.viewers || []);
            let otherCampuses = selectCampusOfInvoice.filter(item => item.invoiceId !== e.target.id) || [];
            if (otherCampuses.length > 0) {
                let campuses = [];
                otherCampuses.forEach(item => {
                    if (item?.campuses?.length > 0) {
                        campuses = [...campuses, ...item.campuses];
                    }
                });
                setDisableCampusOfOtherInvoice(campuses);
            } else {
                setDisableCampusOfOtherInvoice([]);
            }
        }
    }

    const calculateFutureDate = (startDate, weeksToAdd) => {
        let futureDate = new Date(startDate);
        futureDate.setDate(futureDate.getDate() + (weeksToAdd * 7)); // Adding weeks in terms of days (7 days per week)
        return futureDate;
    }

    const getStartOfWeek = (date) => {
        const day = date.getDay();
        // Adjust for Sunday (0) to Monday (1)
        const diff = (day === 0 ? 6 : day - 1);
        return new Date(date.getFullYear(), date.getMonth(), date.getDate() - diff);
    };

    const areDatesInSameWeek = (date1, date2) => {
        const startOfWeek1 = getStartOfWeek(date1);
        const startOfWeek2 = getStartOfWeek(date2);

        return startOfWeek1.getTime() === startOfWeek2.getTime();
    };

    const customStartDateAndEndDateSetting = () => {
        let currentDate = new Date();
        let startDate = new Date(customPeriodSetting?.start_date);
        let endDate = new Date(customPeriodSetting?.end_date);
        let checkEndDateDuringWeek = areDatesInSameWeek(currentDate, endDate);
        // Calculate future dates based on the calculated weeks
        let startDateInvoice = checkEndDateDuringWeek ? startDate : new Date(endDate.setDate(endDate.getDate() + 1));
        let endDateInvoice = checkEndDateDuringWeek ? endDate : calculateFutureDate(endDate, 2);

        return {
            startDateInvoice,
            endDateInvoice
        }
    }

    const handleSelectCampusForInvoice = (e) => {
        // Copy the existing state
        let arrayCampuses = [...selectCampusOfInvoice];

        // Find the selected invoice in the state
        let selectedInvoiceIndex = arrayCampuses.findIndex(item => item.invoiceId === selectedInvoice);

        // If the selected invoice is not in the state, add it
        if (selectedInvoiceIndex === -1) {
            arrayCampuses.push({
                invoiceId: selectedInvoice, campuses: [e.target.id], approvers: approvers,
                viewers: viewers
            });
        } else {
            // If the checkbox is checked, add the campus ID
            if (e.target.checked) {
                // If the selected campus is not already in the array, add it
                if (!arrayCampuses[selectedInvoice]?.campuses?.includes(e.target.id)) {
                    arrayCampuses[selectedInvoice].campuses.push(e.target.id);
                }
            } else {
                // If the checkbox is unchecked, remove the campus ID
                arrayCampuses[selectedInvoice].campuses = arrayCampuses[selectedInvoice].campuses.filter(campusId => campusId !== e.target.id);
            }
        }

        // Update the state
        setSelectCampusOfInvoice(arrayCampuses);
    }

    const handleSubmitTypeInvoices = () => {
        if (typeNumberInvoices === 'split-campuses') {
            handleSplitInvoices();
            setIsOpenPopupSplitInvoice(true);
            if (totalNumberInvoices == 0) {
                handleAddInvoices();
                setSelectedInvoice('0');
            }
            let numberInvoices = parseInt(totalNumberInvoices);
            if (numberInvoices <= 1) {
                notify.show('You need to keep 2 invoices at least for this option');
                return;
            }

            if (data?.notification_setting?.split_invoice_type?.total_invoice != totalNumberInvoices) {
                setSelectedInvoice('0');
            } else {
                handleDataSplitInvoice(data);
            }
            return;
        }

        let customerData = {
            payment_setting: {
                payment_date_option: paymentDateOption,
                period_date: periodPayment
            },
            notification_setting: {
                split_campuses: selectCampusOfInvoice,
                split_invoice_type: {
                    split_type: typeNumberInvoices,
                    total_invoice: totalNumberInvoices
                }
            },
            custom_period_setting: {
                payment_date_option: '',
                start_date: new Date(),
                end_date: new Date(),
            }
        };

        API.updateFinanceSettingCustomer(user.institution_id, customerData).then((response) => {
            notify.show("Updated your setting successfully!");
        });
    }

    const handleSubmitSplitInvoices = () => {
        let numberInvoices = parseInt(totalNumberInvoices);
        if (numberInvoices <= 1) {
            notify.show('You need to keep 2 invoices at least for this option');
            return;
        }
        if (selectCampusOfInvoice.length === 0) {
            notify.show("Invoice campuses can be not empty!");
            return;
        } else {
            if (selectCampusOfInvoice.length != totalNumberInvoices) {
                notify.show("Please choose campuses for all invoices!");
            }

            const isValid = selectCampusOfInvoice.every((invoice, index) => {
                if (invoice.campuses.length === 0) {
                    notify.show(`Invoice ${index + 1} campuses can be not empty!`);
                    return false;
                }
                if (invoice.approvers.length === 0) {
                    notify.show(`Invoice ${index + 1} approvers can be not empty!`);
                    return false;
                }
                if (invoice.viewers.length === 0) {
                    notify.show(`Invoice ${index + 1} viewers can be not empty!`);
                    return false;
                }
                return true;
            });

            if (!isValid) {
                return;
            }
        }
        let customerData = {
            notification_setting: {
                split_campuses: selectCampusOfInvoice,
                split_invoice_type: {
                    split_type: typeNumberInvoices,
                    total_invoice: totalNumberInvoices
                }
            }
        };
        API.updateFinanceSettingCustomer(user.institution_id, customerData).then((response) => {
            setData(response?.data);
            handleDataSplitInvoice(response?.data);
            setIsOpenPopupSplitInvoice(false);
            setTotalNumberInvoices(response?.data.notification_setting?.split_invoice_type?.total_invoice);
            notify.show("Updated your setting successfully!");
        });
    }

    const handleSubmit = () => {
        let customerData = {
            payment_setting: {
                payment_date_option: paymentDateOption,
                period_date: periodPayment,
                purchase_order: {
                    date_of_purchase_order_commencement: purchaseOrder.date_of_purchase_order_commencement,
                    po_number: purchaseOrder.po_number
                }
            },
            notification_setting: {
                split_campuses: typeNumberInvoices === 'split-campuses' ? selectCampusOfInvoice : [],
                split_invoice_type: {
                    split_type: typeNumberInvoices,
                    total_invoice: typeNumberInvoices === 'split-campuses' ? totalNumberInvoices : 0
                }
            },
            custom_period_setting: {
                payment_date_option: '',
                start_date: new Date(),
                end_date: new Date(),
            },
        };

        API.updateFinanceSettingCustomer(user.institution_id, customerData).then((response) => {
            notify.show("Updated your setting successfully!");
        });
    }

    const handleChangeApprovers = (event) => {
        const {
            target: { value },
        } = event;

        setSelectCampusOfInvoice((prevData) => {
            const updatedArray = [...prevData];

            if (selectedInvoice !== null && selectedInvoice !== undefined && selectedInvoice >= 0) {
                updatedArray[selectedInvoice] = {
                    ...updatedArray[selectedInvoice],
                    approvers: value
                };
            }

            return updatedArray;
        });
    };

    const handleChangeViewers = (event) => {
        const {
            target: { value },
        } = event;

        setSelectCampusOfInvoice((prevData) => {
            const updatedArray = [...prevData];

            if (selectedInvoice !== null && selectedInvoice !== undefined && selectedInvoice >= 0) {
                updatedArray[selectedInvoice] = {
                    ...updatedArray[selectedInvoice],
                    viewers: value
                };
            }

            return updatedArray;
        });
    }

    const handleRemoveInvoice = (index) => {
        let numberInvoices = parseInt(totalNumberInvoices) - 1;
        if (numberInvoices <= 1) {
            notify.show('You need to keep 2 invoices at least for this option');
            return;
        }
        if (index == selectedInvoice) {
            setSelectedInvoice(selectedInvoice - 1);
        }
        listSplitInvoices.splice(index, 1);
        const updatedArray = listSplitInvoices.map((item, index) => ({
            description: `Invoice ${index + 1}`,
        }));

        selectCampusOfInvoice.splice(index, 1);
        const updatedCampuses = selectCampusOfInvoice.map((item, index) => ({
            ...item,
            invoiceId: `${index}`,
        }));

        setTotalNumberInvoices(numberInvoices);
        setListSplitInvoices(updatedArray);
        setSelectCampusOfInvoice(updatedCampuses);
    }

    const addNewPersonnel = (e) => {
        e.preventDefault();
        const fields = [
            "personnel_email",
            "personnel_role",
            "personnel_last_name",
            "personnel_first_name",
        ];
        let errors = false;

        for (let field of fields) {
            const input = document.getElementById(field);
            if (!input.reportValidity()) {
                errors = true;
                break;
            }
        }


        if (newPersonnel.campuses.length === 0) {
            notify.show("Please add at least one campus");
            errors = true;
        }

        if (newPersonnel.reference_name.length > 5) {
            notify.show("Nickname max 5 characters");
            errors = true;
        }

        if (
            newPersonnel.personnel_email.toLowerCase() ===
            user.email.toLowerCase()
        ) {
            notify.show(
                "This area is for adding your team members. Account owners should not duplicate their credentials here."
            );
            errors = true;
        }

        const dup_email = personnels.filter((ele) => {
            return (
                ele.personnel_email.toLowerCase() ===
                newPersonnel.personnel_email.toLowerCase()
            );
        });
        // '>1' because the filter will always return the current personnel, but if it returns 2 personnels with the same email, then some exisitng personnel is sharing the same email
        if (dup_email.length > 1) {
            notify.show(
                `You have added the email to Personnel: ${dup_email[0].reference_name}.`
            );
            errors = true;
        }

        const dup_nickname = personnels.filter((ele) => {
            return ele.reference_name === newPersonnel.reference_name;
        });
        // '>1' because the filter will always return the current personnel, but if it returns 2 personnels with the same email, then some exisitng personnel is sharing the same email
        if (dup_nickname.length > 1) {
            notify.show(
                `You have added the same nickname to another personnel: ${dup_nickname[0].reference_name}.`
            );
            errors = true;
        }

        if (!errors) {
            API.createPersonnelV2(newPersonnel).then((result) => {
                notify.show('Personnel successfully added');
                API.getPersonnelByInstId(user?.institution_id).then((response) => {
                    setPersonnels(response?.data);
                });
                setIsPopupAddPersonnel(false);
            });
        }
    }

    const handleSelectCampusForPersonnel = (e) => {
        const updatedCampuses = e.target.checked
            ? [...newPersonnel.campuses, e.target.id]
            : newPersonnel.campuses.filter(campusId => campusId !== e.target.id);

        setNewPersonnel(prev => ({
            ...prev,
            campuses: updatedCampuses
        }));
    }

    const handleFieldsChange = (e) => {
        let original_per = newPersonnel;
        original_per[`${e.target.id}`] = e.target.value;
        setNewPersonnel(preState => ({
            ...preState,
            [e.target.id]: e.target.value
        }));
    };

    const handleDepartChange = (e) => {
        let original_per = newPersonnel;
        if (original_per.personnel_departments.includes(e.target.value)) {
            original_per.personnel_departments.splice(
                original_per.personnel_departments.indexOf(e.target.value),
                1
            );
        } else {
            original_per.personnel_departments.push(e.target.value);
        }
        setNewPersonnel(preState => ({
            ...preState,
            personnel_departments: original_per.personnel_departments
        }));
    };

    const handlePermissions = (e) => {
        setNewPersonnel(preState => ({
            ...preState,
            access_permission: {
                [e.target.title]: e.target.checked
            }
        }))
    };

    const handleCmmChange = (e) => {
        let isGetEmail = false;
        if (newPersonnel[`${e.target.value}`]) {
            isGetEmail = false;
        } else {
            isGetEmail = true;
        }
        setNewPersonnel(preState => ({
            ...preState,
            get_booking_email: isGetEmail
        }));
    };

    const handleSelectSlitOptions = (options) => {
        setTypeNumberInvoices(options);
        handleCheckSelectedSetting(paymentDateOption, options, selectCampusOfInvoice);
    }

    const handleSubmitPeriodSetting = () => {
        API.updateCustomPeriodSetting(user?.institution_id, customPeriodSetting).then(() => {
            setIsPaymentDateCheck('custom-payment-date');
            notify.show('Update custom period setting successfully!');
            setIsOpenCustomDatePopup(false);
            return;
        });
    }

    return (
        <CollegeContainer header="Finance Settings"
            tabs={tabs}
            tabPairs={[]}
            initialIndex={0}
        >
            <Tabs
                value={0}
                fullWidth
                variant="scrollable"
                TabIndicatorProps={{
                    style: { background: "#34F1C8", color: "#34F1C8" }
                }}
                textColor={'primary'}
            >
                <div className="container college-info">
                    <p className="college-form-label">Invoice Date - <i>select the date of your first fortnightly invoice</i></p>
                    <i className="invoice-label">For custom invoice dates, please contact our finance department on finance@readyteacher.com.au</i>
                    <div className="d-flex align-items-center mt-2">
                        <i>Customize your invoice period</i>
                        <button type="button" className="ml-2 btn btn-primary" onClick={() => setIsOpenCustomDatePopup(true)}>Custom</button>
                    </div>
                    <ButtonContainer
                        className="row mt-3 mb-3"
                        twoColumns
                        vertical
                    >
                        <label>Group A</label>
                        <CheckableButton
                            className="col-6 form-check mb-2 pt-2 pb-2"
                            value="payment-date-1"
                            onChange={handleCheckPaymentDate}
                            checked={isPaymentDateCheck === 'payment-date-1'}
                            name="paymentRadio" id="paymentRadio1"
                        >
                            Invoice Delivery Date {dateGroupA?.fortnight_end_date ? moment(dateGroupA?.fortnight_end_date, 'DD/MM/YYYY').format('DD MMM YYYY') : ''}
                            <br />
                            For teaching period {dateGroupA?.fortnight_start_date ? moment(dateGroupA?.fortnight_start_date, 'DD/MM/YYYY').format('DD MMM YYYY') : ''} -  {dateGroupA?.fortnight_end_date ? moment(dateGroupA?.fortnight_end_date, 'DD/MM/YYYY').format('DD MMM YYYY') : ''}
                            <br />
                            <h4>Payment date  {dateGroupA?.teachers_payment_date ? moment(dateGroupA?.teachers_payment_date, 'DD/MM/YYYY').format('DD MMM YYYY') : ''}</h4>
                        </CheckableButton>
                        <label>Group B</label>
                        <CheckableButton
                            className="col-6 form-check mb-2 pt-2 pb-2"
                            name="paymentRadio"
                            id="paymentRadio2"
                            onChange={handleCheckPaymentDate}
                            value="payment-date-2"
                            checked={isPaymentDateCheck === 'payment-date-2'}
                        >
                            Invoice Delivery Date {dateGroupB?.fortnight_end_date ? moment(dateGroupB?.fortnight_end_date, 'DD/MM/YYYY').format('DD MMM YYYY') : ''}
                            <br />
                            For teaching period  {dateGroupB?.fortnight_start_date ? moment(dateGroupB?.fortnight_start_date, 'DD/MM/YYYY').format('DD MMM YYYY') : ''} -  {dateGroupB?.fortnight_end_date ? moment(dateGroupB?.fortnight_end_date, 'DD/MM/YYYY').format('DD MMM YYYY') : ''}
                            <br />
                            <h4>Payment date {dateGroupB?.teachers_payment_date ? moment(dateGroupB?.teachers_payment_date, 'DD/MM/YYYY').format('DD MMM YYYY') : ''}</h4>
                        </CheckableButton>
                    </ButtonContainer>

                    {
                        customPeriodSetting?.payment_date_option && (
                            <ButtonContainer
                                className="row mt-3 mb-3"
                                twoColumns
                                vertical
                            >
                                <label>Custom Period</label>
                                <CheckableButton
                                    className="col-6 form-check mb-2 pt-2 pb-2"
                                    name="paymentRadio"
                                    id="paymentRadio2"
                                    onChange={handleCheckPaymentDate}
                                    value="custom-payment-date"
                                    checked={isPaymentDateCheck === 'custom-payment-date'}
                                >
                                    Invoice Delivery Date {customStartDateAndEndDateSetting()?.startDateInvoice ? moment(customStartDateAndEndDateSetting()?.endDateInvoice).format('DD MMM YYYY') : ''}
                                    <br />
                                    For teaching period  {customStartDateAndEndDateSetting()?.startDateInvoice ? moment(customStartDateAndEndDateSetting()?.startDateInvoice).format('DD MMM YYYY') : ''} -  {customStartDateAndEndDateSetting()?.endDateInvoice ? moment(customStartDateAndEndDateSetting()?.endDateInvoice).format('DD MMM YYYY') : ''}
                                    <br />
                                    <h4>Payment date {customPeriodSetting?.payment_date_option == 'payment-date-1' ? moment(dateGroupA?.teachers_payment_date, 'DD/MM/YYYY').format('DD MMM YYYY') : moment(dateGroupB?.teachers_payment_date, 'DD/MM/YYYY').format('DD MMM YYYY')}</h4>
                                </CheckableButton>
                                <div></div>
                            </ButtonContainer>
                        )
                    }

                    {
                        isOpenPopupSplitInvoice && (
                            <ModalComponent
                                header="Nominate number of invoices"
                                className="finance-modal"
                                show={true}
                                onClose={() => setIsOpenPopupSplitInvoice(false)}
                            >
                                <div className="row">
                                    <div className="col-md-6">
                                        <ButtonContainer
                                            label="Invoices Split"
                                            className="p-0 mx-0"
                                        >
                                            <div className="col-md-12 px-0">
                                                {
                                                    listSplitInvoices?.map((e, index) => {
                                                        return (
                                                            <>
                                                                <div className="d-flex align-items-center">
                                                                    <CheckableButton
                                                                        id={index}
                                                                        title={index}
                                                                        onChange={handleSelectedInvoices}
                                                                        key={index}
                                                                        name="invoices"
                                                                        type={'radio'}
                                                                        className={"col-11 " + (selectedInvoice == index ? '' : 'inactive-selected')}
                                                                        checked={selectedInvoice == index}
                                                                    >
                                                                        {e.description}
                                                                    </CheckableButton>
                                                                    <CloseIcon onClick={() => handleRemoveInvoice(index)} className="mb-1 search-category-arrow-icon" fontSize="medium" />
                                                                </div>
                                                                {
                                                                    selectedInvoice == index && (
                                                                        <>
                                                                            <MultipleSelectChip
                                                                                names={personnels}
                                                                                label={'Approvers'}
                                                                                handleChange={handleChangeApprovers}
                                                                                persons={selectCampusOfInvoice[selectedInvoice]?.approvers || []}
                                                                            />
                                                                            <MultipleSelectChip
                                                                                names={personnels}
                                                                                label={'Viewers'}
                                                                                handleChange={handleChangeViewers}
                                                                                persons={selectCampusOfInvoice[selectedInvoice]?.viewers || []}
                                                                            />
                                                                        </>
                                                                    )
                                                                }
                                                            </>
                                                        )
                                                    })
                                                }

                                                <span className="search-category-arrow-icon" onClick={handleAddInvoices}>
                                                    <i aria-hidden="true" className="#3bb4d8 add circular inverted icon qualification-container-update-icon"> </i>
                                                    <b>Add Invoice Group</b>
                                                </span>
                                                <div className="mt-3">
                                                    <span className="search-category-arrow-icon" onClick={() => setIsPopupAddPersonnel(true)}>
                                                        <i aria-hidden="true" className="#3bb4d8 add circular inverted icon qualification-container-update-icon"> </i>
                                                        <b>Add new personnel</b>
                                                    </span>
                                                </div>
                                            </div>
                                        </ButtonContainer>
                                    </div>
                                    <div className="col-md-6">
                                        <ButtonContainer
                                            label={`Add Campus to Invoice ${parseInt(selectedInvoice) + 1}`}
                                            className="p-0 mx-0"
                                        >
                                            <div className="col-md-12 px-0">
                                                {campuses?.map((campus, index) => {
                                                    return (
                                                        <CheckableButton
                                                            checkbox
                                                            id={campus._id}
                                                            title={index}
                                                            onChange={handleSelectCampusForInvoice}
                                                            checked={selectCampusOfInvoice[selectedInvoice]?.campuses?.includes(campus._id) || false}
                                                            key={index}
                                                            disabled={disableCampusOfOtherInvoice.includes(campus._id)}
                                                        >
                                                            {campus.address_line1 + (campus.address_line2 ? ', ' + campus.address_line2 : '') + ', ' + campus.suburb}
                                                        </CheckableButton>
                                                    );
                                                })}
                                            </div>
                                        </ButtonContainer>
                                    </div>
                                    <div className="col-md-6">
                                        <button onClick={() => setIsOpenPopupSplitInvoice(false)} className="btn btn-block secondary-button-no-margin-hover btn-c button-component">Cancel</button>
                                    </div>
                                    <div className="col-md-6">
                                        <button onClick={handleSubmitSplitInvoices} className="btn btn-primary btn-block primary-button-no-margin-hover btn-c button-component">Submit</button>
                                    </div>
                                </div>
                            </ModalComponent>
                        )
                    }

                    {
                        isPopupAddPersonnel && (
                            <ModalComponent
                                header="Add new Personnel"
                                className="finance-modal"
                                show={true}
                                onClose={() => setIsPopupAddPersonnel(false)}
                            >
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="col-md-12 px-0">
                                            <FormField
                                                label="First name"
                                                id="personnel_first_name"
                                                header={
                                                    <HoverIcon
                                                        icon="info circle"
                                                        color="grey"
                                                        text="Enter manager's name Not your name"
                                                    />
                                                }
                                                required
                                                value={newPersonnel.personnel_first_name}
                                                onChange={handleFieldsChange}
                                                placeholder="First name"
                                            />
                                            <FormField
                                                label="Last name"
                                                id="personnel_last_name"
                                                required
                                                value={newPersonnel.personnel_last_name}
                                                onChange={handleFieldsChange}
                                                placeholder="Last name"
                                            />
                                            <FormField
                                                label="Role title"
                                                id="personnel_role"
                                                value={newPersonnel.personnel_role}
                                                onChange={handleFieldsChange}
                                                placeholder="Role title"
                                                required
                                            />
                                            <FormField
                                                icon="account-check"
                                                label="Email address"
                                                id="personnel_email"
                                                type="email"
                                                value={newPersonnel.personnel_email}
                                                onChange={handleFieldsChange}
                                                // disabled={
                                                // newPersonnel.email_verification_status
                                                // }
                                                // pattern="^([a-zA-Z0-9_\-\.])+@(([A-Za-z0-9_\-\.])+(.edu.au))$"
                                                //pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.+-]+\.edu(?:\.\w{2,3})?$"
                                                title="Please register with institution email"
                                                autoFocus
                                                placeholder="name@xxx.edu.au"
                                                required
                                            />
                                            <FormField
                                                // id="man_shortname"
                                                id="reference_name"
                                                label="Save manager under a nickname"
                                                placeholder="E.g.: Alex (max 5 characters)"
                                                value={
                                                    newPersonnel.reference_name == "unnamed"
                                                        ? Placeholder
                                                        : newPersonnel.reference_name
                                                }
                                                onChange={handleFieldsChange}
                                                maxLength={5}
                                                required
                                            ></FormField>
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <ButtonContainer
                                            label={`Campus/es they work at`}
                                            className="p-0 mx-0"
                                        >
                                            <div className="col-md-12 px-0">
                                                {college?.campuses?.map((campus, index) => {
                                                    return (
                                                        <CheckableButton
                                                            checkbox
                                                            id={campus._id}
                                                            title={index}
                                                            onChange={handleSelectCampusForPersonnel}
                                                            // checked={selectCampusOfInvoice[selectedInvoice]?.campuses?.includes(campus._id) || false}
                                                            key={index}
                                                        >
                                                            {campus.address_line1 + (campus.address_line2 ? ', ' + campus.address_line2 : '') + ', ' + campus.suburb}
                                                        </CheckableButton>
                                                    );
                                                })}
                                            </div>
                                        </ButtonContainer>
                                    </div>
                                    <div className="col-md-6">
                                        <button onClick={() => setIsPopupAddPersonnel(false)} className="btn btn-block secondary-button-no-margin-hover btn-c button-component">Cancel</button>
                                    </div>
                                    <div className="col-md-6">
                                        <button onClick={addNewPersonnel} className="btn btn-primary btn-block primary-button-no-margin-hover btn-c button-component">Submit</button>
                                    </div>
                                </div>
                            </ModalComponent>
                        )
                    }

                    {
                        isOpenCustomDatePopup && (
                            <ModalComponent
                                header="Customize the date period"
                                className="finance-modal height-modal"
                                show={true}
                                onClose={() => setIsOpenCustomDatePopup(false)}
                            >
                                <div className="row">
                                    <div className="col-md-6">
                                        <FormDatePicker
                                            label="Start Date"
                                            onChange={(date) => setCustomPeriodSetting({ start_date: date, end_date: customPeriodSetting.end_date, payment_date_option: customPeriodSetting.payment_date_option })}
                                            value={moment(customPeriodSetting?.start_date).format("DD-MM-YYYY")}
                                            dateFormat="YYYY-MM-DD"
                                            maxWidth
                                            required
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <FormDatePicker
                                            label="End Date"
                                            onChange={(date) => setCustomPeriodSetting({ start_date: customPeriodSetting.start_date, end_date: date, payment_date_option: customPeriodSetting.payment_date_option })}
                                            value={moment(customPeriodSetting?.end_date).format("DD-MM-YYYY")}
                                            dateFormat="YYYY-MM-DD"
                                            maxWidth
                                            required
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <FormDropdown
                                            label="Group setting"
                                            id='group-setting'
                                            // icon='sort'
                                            onChange={value => setCustomPeriodSetting({ start_date: customPeriodSetting.start_date, end_date: customPeriodSetting.end_date, payment_date_option: value.target.value })}
                                            placeholder='Choose your group settings'
                                            required
                                        >
                                            <option value='payment-date-1'>Group A</option>
                                            <option value='payment-date-2'>Group B</option>
                                        </FormDropdown>
                                    </div>
                                    <div className="col-md-6"></div>
                                </div>
                                <div className="row mt-3">
                                    <div className="col-md-6">
                                        <button onClick={() => setIsOpenCustomDatePopup(false)} className="btn btn-block secondary-button-no-margin-hover btn-c button-component">Cancel</button>
                                    </div>
                                    <div className="col-md-6">
                                        <button onClick={handleSubmitPeriodSetting} className="btn btn-primary btn-block primary-button-no-margin-hover btn-c button-component">Submit</button>
                                    </div>
                                </div>
                            </ModalComponent>
                        )
                    }
                    <p className="college-form-label">Split Invoices Options</p>
                    <ButtonContainer
                        className="row mt-3 mb-3"
                        twoColumns
                        vertical
                    >
                        <CheckableButton
                            value={"all-campuses"}
                            onChange={() => handleSelectSlitOptions('all-campuses')}
                            className="mb-2 text-wrap"
                            name="splitOption" id="splitOption"
                            defaultChecked
                            checked={typeNumberInvoices === 'all-campuses'}
                        >
                            Issue 1 invoice for all campuses
                        </CheckableButton>
                        <CheckableButton
                            value={"split-campuses"}
                            onChange={() => handleSelectSlitOptions('split-campuses')}
                            className="mb-2 text-wrap"
                            name="splitOption" id="splitOption2"
                            checked={typeNumberInvoices === 'split-campuses'}
                        >
                            Separate invoices by campus
                        </CheckableButton>
                    </ButtonContainer>
                    <div className="mt-2">
                        <p>Approves invoice: {existedPersonnels?.filter(personnel => personnel?.access_permission?.manage_payment).map(personnel => personnel?.personnel_first_name + ' ' + personnel?.personnel_last_name).join(', ')}</p>
                        <p>Receives invoice: {existedPersonnels?.filter(personnel => personnel?.access_permission?.receives_invoice_copy).map(personnel => personnel?.personnel_first_name + ' ' + personnel?.personnel_last_name).join(', ')}</p>
                        <a href="/Personnel" className="text-primary">To make changes visit the Personnel page.</a>
                    </div>

                    <div className="mt-2">
                        <h2 className="bold">Purchase Order Number (Optional)</h2>
                        <div className="row">
                        <FormField
                            icon="calendar"
                            label="Date of purchase order commencement"
                            type="date"
                            className="col-md-6"
                            id="date_of_purchase_order_commencement"
                            value={purchaseOrder.date_of_purchase_order_commencement}
                            placeholder="Date of purchase order commencement"
                            onChange={(e) => setPurchaseOrder({ ...purchaseOrder, date_of_purchase_order_commencement: e.target.value })}
                        />
                        <FormField
                            icon="text"
                            label="PO Number"
                            type="text"
                            className="col-md-6"
                            id="po_number"
                            value={purchaseOrder.po_number}
                            placeholder="PO Number"
                            onChange={(e) => setPurchaseOrder({ ...purchaseOrder, po_number: e.target.value })}
                        />
                        </div>
                    </div>
                    {
                        typeNumberInvoices === 'split-campuses' && (
                            <button type="button" className="btn btn-light btn-block primary-button-no-margin-hover btn-c split-campuses-btn" onClick={handleSubmitTypeInvoices}>Split campuses</button>
                        )
                    }
                    <div>
                        <button disabled={isDisabled} type="button" className="btn btn-primary btn-block primary-button-no-margin-hover btn-c button-component" onClick={handleSubmit}>{'Submit'}</button>
                    </div>
                </div>
            </Tabs>
            {/* </SwipeableViews> */}
        </CollegeContainer>
    );
}

export default connect(null, null)(FinanceSetting);